import { render } from "./Heading.vue?vue&type=template&id=1f079714&scoped=true&ts=true"
import script from "./Heading.vue?vue&type=script&lang=ts"
export * from "./Heading.vue?vue&type=script&lang=ts"

import "./Heading.vue?vue&type=style&index=0&id=1f079714&scoped=true&lang=css"

import exportComponent from "/code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f079714"]])

export default __exports__